import { gql } from '../__generated__/gql';

export const CREATE_SERVICE = gql(`
  mutation CreateServiceAndUploadImageFile($data: CustomServiceCreateInput!) {
    createServiceAndUploadImageFile(data: $data) {
      ...ServiceFields
    }
  }
`);
